/**
 * @lodex-pro/web-portal/components/ScopeNotice — OPP PR 8. Pumpers and foremen see only the
 * tanks they selected (a foreman also his routes' tanks) in Tickets, Volumes and Tanks; this
 * one muted line says so and links to My tanks. The admin sees the whole company: no line.
 */

import React from 'react';
import { Link } from 'react-router-dom';
import type { OperatorPortalMeResponse } from '@lodex-pro/shared/validation/operator-portal-me';

export function ScopeNotice({
  me,
}: {
  readonly me: OperatorPortalMeResponse | undefined;
}): React.JSX.Element | null {
  if (me?.roleCode !== 'PUMPER' && me?.roleCode !== 'FOREMAN') return null;
  return (
    <p
      style={{
        color: 'var(--color-text-tertiary)',
        fontSize: '13px',
        marginTop: 0,
        marginBottom: '12px',
      }}
    >
      Showing the tanks you&rsquo;ve selected. Change them in{' '}
      <Link to="/portal/my-tanks" style={{ color: 'var(--color-link)' }}>
        My tanks
      </Link>
      .
    </p>
  );
}
